<template>
  <div>
    <div>
      <a-modal
        :title="$t('translateText.tip')"
        :visible="visible"
        :locale="locale"
        @ok="handleOk"
        @cancel="handleCancel"
        class="modal"
        :ok-text="$t('translateText.ok')"
        :cancel-text="$t('translateText.cancel')"
      >
        <div>
          <img src="@/assets/imgs/course/mark.png" alt="icon" style="" />
          <slot></slot>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN' // 汉化

/*
@params{

    事件名称	说明	                                  回调参数

    cancel	    点击遮罩层或右上角叉或取消按钮的回调     	function(e)

    ok	        点击确定回调	                          function(e)


    ==================================================================

    visible:     控制组件的显示隐藏
}

*/
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale: zhCN, //区域：中国
    }
  },
  methods: {
    handleOk(e) {
      //   this.visible = false;
      // this.$router.push("StudentCourse/StudentCourseInfo");

      this.$emit('confirm', e)
      this.$emit('mul_key', true)
    },
    handleCancel(e) {
      // this.visible = false;
      this.$emit('cancel', e)
    },
  },
}
</script>

<style lang="less" scoped>
.modal {
  /deep/ .ant-modal {
    width: 450px !important;
    top: 40%;
    left: 6%;
    // transform: translate(30%,50%);
  }
  @media (max-width: 769px) {
    /deep/ .ant-modal {
      left: 0%;
    }
  }
  /deep/ .ant-modal-header {
    padding: 13px 24px;
    border: unset;
    border-radius: 4px 4px 0 0;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    background: #f4f4f4;
    .ant-modal-title {
      font-size: 17px;
      font-weight: 600;
      color: unset;
    }
  }

  /deep/ .ant-modal-body {
    padding: 46px;
    text-align: center;
    img {
      width: 18px;
      height: 18px;
      margin-right: 5px;
      vertical-align: text-bottom;
    }
  }
  /deep/ .ant-modal-footer {
    background: #f4f4f4;
    border: unset;
  }
  /deep/ .ant-modal-footer > div > button:nth-child(1) {
    border: 1px solid #7c838d;
    padding: 2px 20px;
    border-radius: 4px;
    color: #7c838d;
    background: #f4f4f4;
  }
  /deep/ .ant-modal-footer > div > button:nth-child(2) {
    padding: 2px 20px;
    border-color: #2eadb5;
    margin: 0 5px 0 16px;
    color: #fff;
    background-color: #2eadb5;
  }
}
</style>
